// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c3e0ba0b","453":"9965fd5d","667":"526fce1d"}[chunkId] + ".chunk.js";
};